import React from "react";
import { withTranslation } from "react-i18next";
import { ConfigurationPanelView } from "../../views";
import {
  ContractService,
  PlanService,
  LocalStorageService,
  ClientService,
} from "../../../services/index";
import initialState from "../../../utils/initialState";
import { HistoricPlan } from "../../../assets/logos";

class ConfigurationPanelAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      planName: "",
      signsAvailable: "",
      totalAvailableSigns: "",
      totalPendingSign: "",
      totalSigns: "",
      expirationDate: "",
      contractPlanExist: false,
      title: props.t("configurationPanelView.titleContracts"),

      cardConfiguration: [
        {
          img: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_pay.png",
          imgBackCard:
            "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_1.png",
          altImg: props.t("configurationPanelView.planRenovation"),
          title: props.t("configurationPanelView.planRenovation"),
          text: props.t("configurationPanelView.planRenovationText"),
          url: "/new-plan-renovation/",
        },
        {
          img: HistoricPlan,
          imgBackCard:
            "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_2.png",
          altImg: props.t("configurationPanelView.contractsHistory"),
          title: props.t("configurationPanelView.contractsHistory"),
          text: props.t("configurationPanelView.contractsHistoryText"),
          url: "/configuration-contracts-history/",
        },
        // {
        //   img: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_signed_with_time.png",
        //   imgBackCard:
        //     "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_3.png",
        //   altImg: props.t("configurationPanelView.creditsHistory"),
        //   title: props.t("configurationPanelView.creditsHistory"),
        //   text: props.t("configurationPanelView.creditsHistoryText"),
        //   url: "/configuration-signature-history/",
        // },
        // {
        //   img: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_teams.png",
        //   imgBackCard:
        //     "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_4.png",
        //   altImg: props.t("configurationPanelView.administrateSigners"),
        //   title: props.t("configurationPanelView.administrateSigners"),
        //   text: props.t("configurationPanelView.administrateText"),
        //   url: "/configuration-administer/",
        // },
        {
          img: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_search.png",
          imgBackCard:
            "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_5.png",
          altImg: props.t("configurationPanelView.domains"),
          title: props.t("configurationPanelView.domains"),
          text: props.t("configurationPanelView.domainsText"),
          url: "/configuration-domain",
        },
        {
          img: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_certificate.png",
          imgBackCard:
            "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_1.png",
          altImg: props.t("configurationPanelView.signatureProfiles"),
          title: props.t("configurationPanelView.signatureProfiles"),
          text: props.t("configurationPanelView.signatureProfilesText"),
          url: "/signature-profile",
        },
        // {
        //   img: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_certificate.png",
        //   imgBackCard:
        //     "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_1.png",
        //   altImg: props.t("configurationPanelView.Questionnaries.altImg"),
        //   title: props.t("configurationPanelView.Questionnaries.title"),
        //   text: props.t("configurationPanelView.Questionnaries.text"),
        //   url: "/questionnaire-administration",
        // },
        {
          img: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_teams.png",
          imgBackCard:
            "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_4.png",
          altImg: props.t("configurationPanelView.userAdministrationImgAlt"),
          title: props.t("configurationPanelView.userAdministrationTitle"),
          text: props.t("configurationPanelView.userAdministrationText"),
          url: "/user-administration",
        },
        {
          img: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/administrar_empresa.svg",
          imgBackCard:
            "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_1.png",
          altImg: props.t("configurationPanelView.businessAdministrationTitle"),
          title: props.t("configurationPanelView.businessAdministrationTitle"),
          text: props.t("configurationPanelView.businessAdministrationText"),
          url: "/business-administration",
        },
        {
          img: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_settings.png",
          imgBackCard:
            "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_6.png",
          altImg: props.t("configurationPanelView.personalize"),
          title: props.t("configurationPanelView.personalize"),
          text: props.t("configurationPanelView.personalizeText"),
          url: "/customization",
        },
        {
          img: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/administrarinvitados.svg",
          imgBackCard:
            "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_6.png",
          altImg: props.t("configuration.administrateInvitedUsers"),
          title: props.t("configuration.administrateInvitedUsers"),
          text: props.t("configuration.administrateInvitedUsers.description"),
          url: "/administrate-invited",
        }
        // {
        //   img: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_settings.png",
        //   imgBackCard:
        //     "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_1.png",
        //   altImg: props.t("configurationPanelView.digitalContractTemplates"),
        //   title: props.t("configurationPanelView.digitalContractTemplates"),
        //   text: props.t("configurationPanelView.digitalContractTextTemplates"),
        //   url: "/digital-contract",
        // },
        // {
        //   img: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_settings.png",
        //   imgBackCard:
        //     "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_1.png",
        //   altImg: props.t("configurationPanelView.digitalContractTemplates"),
        //   title: props.t("contractRequest.cardTitle"),
        //   text: props.t("contractRequest.cardText"),
        //   url: "/contract-request",
        // },
        // {
        //   img: 'https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_settings.png',
        //   imgBackCard: 'https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_1.png',
        //   altImg: props.t('configurationPanelView.digitalContractTemplates'),
        //   title: props.t('Seguimiento de Contrato'),
        //   text: props.t('Prueba QA'),
        //   url: '/followup-contracts'
        // },
        // {
        //   img: 'https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_settings.png',
        //   imgBackCard: 'https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_1.png',
        //   altImg: props.t('configurationPanelView.digitalContractTemplates'),
        //   title: 'Pantalla de Detalle y Acciones Seguimiento a Contratos',
        //   text: 'Pantalla de Detalle y Acciones Seguimiento a Contratos',
        //   url: '/followup-actions-contracts'
        // },
        // {
        //   img: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_settings.png",
        //   imgBackCard:
        //     "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/background_1.png",
        //   altImg: props.t("configurationPanelView.digitalContractTemplates"),
        //   title: props.t("Seguimiento a nuevo contratante"),
        //   text: props.t("Prueba QA"),
        //   url: "/followup-new-recruiter",
        // }
      ],
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  contractService = new ContractService(this.url);
  planService = new PlanService(this.url);

  async componentDidMount() {
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let userContractPlan = initialState["planService.getUserContractAndPlan"];
    userContractPlan = await this.planService.getUserContractAndPlan(
      this.token
    );
    initialState["planService.getUserContractAndPlan"] = userContractPlan;

    let contractCountTransactions =
      await this.contractService.getContractsTotalTransactions(this.token);

    if (
      userContractPlan.statusCode &&
      userContractPlan.statusCode === -1 &&
      contractCountTransactions.statusCode === 200
    ) {
      this.setState({
        contractPlanExist: false,
        loading: false,
      });
    } else {
      let dataSignature =
        userContractPlan.data.contract.endOfContract.split("T")[0];
      let yearSignature = dataSignature.split("-")[0];
      let monthSignature = dataSignature.split("-")[1];
      let daySignature = dataSignature.split("-")[2];
      let dateComplete =
        daySignature + "-" + monthSignature + "-" + yearSignature;
      this.setState({
        planName: userContractPlan?.data?.plan?.name,
        signsAvailable:
          contractCountTransactions?.data?.totalAvailableTransactions,
        totalAvailableSigns: contractCountTransactions?.data?.totalTransactions,
        totalPendingSign:
          contractCountTransactions?.data?.totalPendingTransactions,
        totalSigns: userContractPlan?.data?.contract?.annualTransaction,
        expirationDate: dateComplete,
        contractPlanExist: true,
        loading: false,
      });

      // this.state.cardConfiguration = this.state.cardConfiguration.map(
      //   (card) => {
      //     if (card.url === "/configuration-signature-history/") {
      //       card.text =
      //         this.props.t("configurationPanelView.creditsAvailable") +
      //         " " +
      //         this.state.signsAvailable;
      //       card.text2 =
      //         this.props.t("configurationPanelView.creditsPending") +
      //         " " +
      //         this.state.totalPendingSign;
      //       card.text3 =
      //         this.props.t("configurationPanelView.creditsTotal") +
      //         " " +
      //         this.state.totalAvailableSigns;
      //     }
      //     return card;
      //   }
      // );
      // this.setState({ cardConfiguration: this.state.cardConfiguration });
    }
  }

  async sendClientImage(img) {
    let data = new FormData();
    data.append("image", img);
    let clientService = new ClientService(process.env.REACT_APP_MIFIRMA_API);
    let localStorageService = new LocalStorageService();
    let token = localStorageService.getLocalStorageItem("token").idToken;
    return await clientService.sendClientImage(token, data);
  }

  render() {
    return (
      <ConfigurationPanelView
        {...this.state}
        sendClientImage={this.sendClientImage}
      />
    );
  }
}

export default withTranslation()(ConfigurationPanelAction);
